import { Fragment } from 'react';
import { Box, Typography } from '@mui/material';

import { ItineraryStop } from '../circuits';

/**
 * La cadena del recorrido, DERIVADA del itinerario (el contrato no publica una
 * lista de paradas: publica un título por día). El número en superíndice son
 * los días consecutivos en esa ciudad, y solo aparece cuando los títulos son
 * ciudades limpias — ver `itineraryCityChain`.
 */
export function CircuitItineraryChain({
  stops,
  withDays,
  tail,
}: {
  stops: ItineraryStop[];
  withDays: boolean;
  tail?: string;
}) {
  return (
    <Typography
      noWrap
      sx={{ fontSize: 13, fontWeight: 500, lineHeight: 1.35 }}
      title={stops.map((stop) => stop.city).join(' → ')}
    >
      {stops.map((stop, index) => (
        <Fragment key={`${stop.city}-${index}`}>
          {index > 0 && (
            <Box component="span" color="text.disabled" sx={{ mx: 0.875, fontSize: 11 }}>
              →
            </Box>
          )}
          {stop.city}
          {withDays && stop.days > 1 && (
            <Box
              component="sup"
              color="text.secondary"
              sx={{ fontSize: 9.5, ml: 0.25, fontWeight: 600 }}
            >
              {stop.days}
            </Box>
          )}
        </Fragment>
      ))}
      {tail && (
        <Box component="span" color="text.disabled" sx={{ ml: 0.875 }}>
          {tail}
        </Box>
      )}
    </Typography>
  );
}
